<script lang="ts">
	import type { Action } from "svelte/action";
	import type { Snippet } from "svelte";
	import type { HTMLAttributes } from "svelte/elements";
	import { cn } from "#lib/web-ui/ui/utils.js";

	let {
		children,
		visibleMargin = "200px",
		class: className,
		...restProps
	}: HTMLAttributes<HTMLDivElement> & {
		children: Snippet;
		visibleMargin?: string;
	} = $props();

	let isVisible = $state(false);

	const lazyLoad: Action<HTMLElement> = (node) => {
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					isVisible = true;
					observer.disconnect();
				}
			},
			{ rootMargin: visibleMargin }
		);
		observer.observe(node);
		return { destroy: () => observer.disconnect() };
	};
</script>

<div class={cn(className)} use:lazyLoad {...restProps}>
	{#if isVisible}
		{@render children()}
	{/if}
</div>
